<div [style.height]="cellHeight" [style.width]="cellWidth" class="checkbox-container">
  <input #checkBoxInput [disabled]="isEnabled ? null : 'disabled'" type="checkbox" [(ngModel)]="isChecked" (blur)="focusOut()" (change)="selectionChanged($event)" />
</div>
